import React, {FC, useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import {useCognitoAuth} from '../modules/auth'
import {WelcomeHeader} from '../../ui/layout/components/header/WelcomeHeader'
import {Footer} from '../../ui/layout/components/Footer'

const WelcomePage: FC = () => {
  const {currentUser} = useCognitoAuth()
  const navigate = useNavigate()

  useEffect(() => {
    // Check if user is authenticated and redirect to dashboard
    if (currentUser && currentUser.identity_id) {
      navigate('/dashboard', {replace: true})
    }
  }, [currentUser, navigate])

  // Don't render the welcome page content if user is authenticated
  // This prevents flash of content before redirect
  if (currentUser && currentUser.identity_id) {
    return null
  }

  return (
    <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
      <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
        {/* Header */}
        <WelcomeHeader />

        {/* Main Content */}
        <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
          <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
            <div className='d-flex flex-column flex-column-fluid'>
              {/* Content */}
              <div id='kt_app_content' className='app-content flex-column-fluid'>
                <div id='kt_app_content_container' className='app-container container-fluid'>
                  {/* Welcome Page Content - Blank for now */}
                  <div className='welcome-content'>{/* Content will be added later */}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    </div>
  )
}

export {WelcomePage}
